import React from 'react';

export default function NursePageHeader({ badge, title, description, actions }) {
  return (
    <header className="nr-page-header nr-no-print mb-4">
      <div className="nr-page-header__main">
        <div className="nr-page-header__text">
          {badge && <span className="nr-page-header__badge">{badge}</span>}
          <h1 className="nr-page-title mb-1">{title}</h1>
          {description && <p className="nr-page-header__desc mb-0">{description}</p>}
        </div>
        {actions ? <div className="nr-page-header__actions">{actions}</div> : null}
      </div>
    </header>
  );
}
